package app.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.datetime.Instant

@Serializable
data class Deployable(
    val id: Int,
    val name: String,
    val creationDate: Instant,
    val version: Version,
    val data: DeployableData,
)

@Serializable
sealed interface DeployableData

@Serializable
@SerialName("ecr")
data class EcrDeployable(
    val imageTag: String,
) : DeployableData {
    init {
        require(imageTag.isNotBlank()) { "imageTag cannot be empty for EcrDeployable" }
    }
}

@Serializable
@SerialName("s3")
data class S3Deployable(
    val fileName: String,
) : DeployableData {
    init {
        require(fileName.isNotBlank()) { "fileName cannot be empty for S3Deployable" }
    }
}

@Serializable
@SerialName("lambda")
data class LambdaDeployable(
    val fileName: String,
) : DeployableData {
    init {
        require(fileName.isNotBlank()) { "fileName cannot be empty for LambdaDeployable" }
    }
}
